<script setup lang="ts">
import type { HTMLAttributes } from 'vue';

defineProps<{ class?: HTMLAttributes['class'] }>();
</script>

<template>
  <span
    :class="cn('h-1.5 w-1.5 shrink-0 rounded-full bg-brand-primary-700 transition-colors duration-150', $props.class)"
    aria-hidden="true"
  />
</template>
